import { message } from 'antd';
import moment from 'moment';
import { selectByPage, detailsOfWaybillDurationExport } from '@/services/waybillDurationNew';
export default {
  namespace: 'waybillDurationNew',
  state: {
    search: {
      signTime: moment()
        .add(-1, 'day')
        .format('YYYY-MM-DD'),
    },
    dataList: [],
    page: 1,
    pageSize: 20,
    total: 0,
  },
  effects: {
    *getList(_, { call, put, select }) {
      const waybillDurationNew = yield select(({ waybillDurationNew }) => waybillDurationNew);
      const { search, page, pageSize } = waybillDurationNew;
      const {
        waybillNo,
        signTime,
        firstOperationAreaCode,
        destOperationAreaCode,
        firstCenterCode,
        destCenterCode,
      } = search;
      if (waybillNo) {
        if (`${waybillNo}`.length !== 12) {
          message.warn('运单号长度为12位,请输入正确单号！');
          return;
        }
      }
      if (!signTime) {
        message.warn('签收时间必填，请选择');
        return;
      }
      const params = {
        ...search,
        page,
        pageSize,
        startTime: signTime && moment(signTime).format('YYYY-MM-DD 00:00:00'),
        signTime: signTime && moment(signTime).format('YYYY-MM-DD 23:59:59'),
        firstOperationAreaCode: firstOperationAreaCode?.code,
        destOperationAreaCode: destOperationAreaCode?.code,
        firstCenterCode: firstCenterCode?.code,
        destCenterCode: destCenterCode?.code,
      };
      const { code, data } = yield call(selectByPage, params);
      if (code === 1) {
        yield put({
          type: 'update',
          payload: {
            total: data?.data?.total,
            dataList: data?.data?.rows || [],
          },
        });
      }
    },
    *exportData({ payload }, { select, call }) {
      const { search, page, pageSize } = yield select(
        ({ waybillDurationNew }) => waybillDurationNew,
      );
      const {
        firstOperationAreaCode,
        destOperationAreaCode,
        firstCenterCode,
        destCenterCode,
        signTime,
      } = search;
      const params = {
        ...payload,
        ...search,
        page,
        pageSize,
        startTime: signTime && moment(signTime).format('YYYY-MM-DD 00:00:00'),
        signTime: signTime && moment(signTime).format('YYYY-MM-DD 23:59:59'),
        firstOperationAreaCode: firstOperationAreaCode?.code,
        destOperationAreaCode: destOperationAreaCode?.code,
        firstCenterCode: firstCenterCode?.code,
        destCenterCode: destCenterCode?.code,
      };
      const { code } = yield call(detailsOfWaybillDurationExport, params);
      if (code === 1) {
        message.success('导出成功');
      }
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    updateSearch(state, { payload }) {
      return { ...state, search: { ...state.search, ...payload } };
    },
  },
};
